/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbMobileRefineMenuFilterCaratWeight_searchBrowse$ref = any;
type SbMobileRefineMenuFilterCategory_searchBrowse$ref = any;
type SbMobileRefineMenuFilterDeliveryOptions_searchBrowse$ref = any;
type SbMobileRefineMenuFilterDimensions_searchBrowse$ref = any;
type SbMobileRefineMenuFilterPrice_searchBrowse$ref = any;
type SbMobileRefineMenuFilterStoneCut_searchBrowse$ref = any;
type SbRespRefineMenuFilterCaratWeight_searchBrowse$ref = any;
type SbRespRefineMenuFilterCategory_searchBrowse$ref = any;
type SbRespRefineMenuFilterDeliveryOptions_searchBrowse$ref = any;
type SbRespRefineMenuFilterDimensions_searchBrowse$ref = any;
type SbRespRefineMenuFilterPrice_searchBrowse$ref = any;
type SbRespRefineMenuFilterStoneCut_searchBrowse$ref = any;
type SbSharedRefineMenuFilterAvailability_searchBrowse$ref = any;
type SbSharedRefineMenuFilterColor_searchBrowse$ref = any;
type SbSharedRefineMenuFilterCreator_searchBrowse$ref = any;
type SbSharedRefineMenuFilterItemType_searchBrowse$ref = any;
type SbSharedRefineMenuFilterMatchingSets_searchBrowse$ref = any;
type SbSharedRefineMenuFilterMaterial_searchBrowse$ref = any;
type SbSharedRefineMenuFilterMetal_searchBrowse$ref = any;
type SbSharedRefineMenuFilterOrigin_searchBrowse$ref = any;
type SbSharedRefineMenuFilterPeriod_searchBrowse$ref = any;
type SbSharedRefineMenuFilterStone_searchBrowse$ref = any;
type SbSharedRefineMenuFilterStyle_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilters_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilters_searchBrowse = {|
  +$fragmentRefs: SbRespRefineMenuFilterPrice_searchBrowse$ref & SbSharedRefineMenuFilterStone_searchBrowse$ref & SbSharedRefineMenuFilterMetal_searchBrowse$ref & SbSharedRefineMenuFilterColor_searchBrowse$ref & SbMobileRefineMenuFilterPrice_searchBrowse$ref & SbSharedRefineMenuFilterStyle_searchBrowse$ref & SbSharedRefineMenuFilterOrigin_searchBrowse$ref & SbSharedRefineMenuFilterPeriod_searchBrowse$ref & SbRespRefineMenuFilterCategory_searchBrowse$ref & SbRespRefineMenuFilterStoneCut_searchBrowse$ref & SbSharedRefineMenuFilterCreator_searchBrowse$ref & SbMobileRefineMenuFilterStoneCut_searchBrowse$ref & SbMobileRefineMenuFilterCategory_searchBrowse$ref & SbSharedRefineMenuFilterMaterial_searchBrowse$ref & SbRespRefineMenuFilterDeliveryOptions_searchBrowse$ref & SbMobileRefineMenuFilterDeliveryOptions_searchBrowse$ref & SbSharedRefineMenuFilterItemType_searchBrowse$ref & SbRespRefineMenuFilterDimensions_searchBrowse$ref & SbRespRefineMenuFilterCaratWeight_searchBrowse$ref & SbMobileRefineMenuFilterDimensions_searchBrowse$ref & SbMobileRefineMenuFilterCaratWeight_searchBrowse$ref & SbSharedRefineMenuFilterAvailability_searchBrowse$ref & SbSharedRefineMenuFilterMatchingSets_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilters_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterStoneCut_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterColor_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStyle_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterPeriod_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCategory_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterStoneCut_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCategory_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterItemType_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCaratWeight_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCaratWeight_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterAvailability_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMatchingSets_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c853f71b1f8fa4d202fdaa8ba38b7385';
module.exports = node;
